import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

/**
 * Empty scope state: "No scope defined yet" + Add scope CTA.
 * Only shown when load has finished and scope is definitively empty.
 */
// `bare` drops the card chrome, the heading and the illustration so this can sit as one row
// inside a larger details panel, which already supplies the surface and the label.
const EmptyScopeState = ({ onOpenBuilder, isRefreshing, bare }) => {
  const body = (
    <div className={bare ? "" : "text-center py-6"}>
      {!bare && (
        <div className="mb-2">
          <FontAwesomeIcon
            icon={icon({ name: "layer-group", style: "solid" })}
            className="text-text-3 text-2xl"
          />
        </div>
      )}
      <p className="text-sm font-medium text-text mb-1">
        No scope defined yet.
      </p>
      {!bare && (
        <p className="text-xs text-text-2 mb-4 max-w-xs mx-auto">
          Add scope to define which costs this budget governs.
        </p>
      )}
      {onOpenBuilder &&
        (bare ? (
          <button
            type="button"
            onClick={onOpenBuilder}
            className="text-sm font-medium text-primary hover:text-primary-hover transition-colors cursor-pointer"
          >
            Add scope
          </button>
        ) : (
          <button
            type="button"
            onClick={onOpenBuilder}
            className="inline-flex items-center gap-1.5 px-4 py-1.5 text-sm font-medium text-white bg-primary hover:bg-primary-hover rounded-ctrl transition-colors duration-150 cursor-pointer"
          >
            <FontAwesomeIcon
              icon={icon({ name: "plus", style: "solid" })}
              className="text-xs"
            />
            Add scope
          </button>
        ))}
    </div>
  );

  if (bare) {
    return (
      <div>
        {isRefreshing && <p className="text-xs text-text-2 mb-2">Refreshing…</p>}
        {body}
      </div>
    );
  }

  return (
    <section className="bg-card border border-card-bd rounded-card p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-text uppercase tracking-wide">
          Budget scope
        </h3>
        {isRefreshing && (
          <span className="text-xs text-text-2">Refreshing…</span>
        )}
      </div>
      {body}
    </section>
  );
};

EmptyScopeState.propTypes = {
  onOpenBuilder: PropTypes.func,
  isRefreshing: PropTypes.bool,
  bare: PropTypes.bool,
};

EmptyScopeState.defaultProps = {
  isRefreshing: false,
};

export default EmptyScopeState;
